import React, { FC, useEffect, useRef, useState } from 'react';

import { Col, Container, Row } from 'layout';
import PolicyMostViewedBoxes from 'components/PolicyMostViewedBoxes';
import PopularTopics from 'components/PopularTopics';
import { isBrowser } from 'utils/browser';

import CustomClearRefinement from './CustomClearRefinement';
import CustomRefinementList from './CustomRefinementList';
import CustomSearchBox from './CustomSearchBox';
import CustomStats from './CustomStats';
import { FiltersProps } from './models';

import './Filters.scss';

const Filters: FC<FiltersProps> = ({
  searchBtnText,
  selectedFiltersText,
  searchPlaceholder,
  firstFilterText,
  secondFilterText,
  filters,
  numberOfResultsText,
  clearFiltersText,
  popularTopics,
  mostViewedBoxes,
  clear,
  resetClear,
}) => {
  const [isCleared, setIsCleared] = useState<boolean>(false);
  const resultsRef = useRef<HTMLDivElement>(null);
  const [screen, setScreen] = useState<number | boolean>();

  useEffect(() => {
    if (isBrowser()) {
      setScreen(window.innerWidth);
    }
  }, []);

  const handleSearchChange = () => {
    setIsCleared(false);
    resetClear();
  };

  const handleCheckedChange = () => {
    setIsCleared(false);
    resetClear();
  };

  const handlePrepareForClear = () => {
    setIsCleared(false);
    resetClear();

    if (!screen) return;

    resultsRef.current?.scrollIntoView();
  };

  const handleClear = () => {
    setIsCleared(true);
    clear();
  };

  return (
    <>
      {popularTopics ? (
        <PopularTopics
          title={popularTopics.title}
          items={popularTopics.items}
          onHandleClear={handleClear}
          prepareForClear={handlePrepareForClear}
        />
      ) : null}
      {mostViewedBoxes ? (
        <PolicyMostViewedBoxes
          title={mostViewedBoxes.title}
          items={mostViewedBoxes.boxes}
          onHandleClear={handleClear}
          prepareForClear={handlePrepareForClear}
        />
      ) : null}
      <section className="filters">
        <Container>
          <div ref={resultsRef} className="filters__holder">
            <form onSubmit={(e) => e.preventDefault()}>
              <Row className="filters__row-filters">
                <Col
                  xl={filters.length === 1 ? '8' : (12 / filters.length).toString()}
                  md="12"
                  sm="12"
                  className="col--no-gutters filters__col-filters"
                >
                  <CustomSearchBox
                    searchBtnText={searchBtnText}
                    searchPlaceholder={searchPlaceholder}
                    isCleared={isCleared}
                    handleSearchChange={handleSearchChange}
                  />
                </Col>
                {filters?.map((filter, index) => (
                  <Col
                    xl={
                      filters.length === 1 ? '4' : (12 / filters.length / filters.length).toString()
                    }
                    md={(12 / filters.length).toString()}
                    sm="12"
                    className="col--no-gutters filters__col-dropdown filters__col-filters"
                    key={filter}
                  >
                    <CustomRefinementList
                      filter={filter}
                      id={filter}
                      handleCheckedChange={handleCheckedChange}
                      selectedFiltersText={selectedFiltersText}
                      filterText={index === 0 ? firstFilterText : secondFilterText}
                    />
                  </Col>
                ))}
              </Row>
            </form>
            <Row className="filters__row-stats-clear">
              <Col sm="7" className="col--no-gutters">
                <CustomStats followedText={numberOfResultsText} />
              </Col>
              <Col sm="5" className="col--no-gutters filters__col-clear">
                <CustomClearRefinement
                  clearBtnText={clearFiltersText}
                  onHandleClear={handleClear}
                  isCleared={isCleared}
                />
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Filters;
